import styled from 'styled-components';

import { colors } from 'theme/colors';

export const SeparatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Header = styled.h1`
  display: flex;
  color: ${colors.ui.chip.grayText};
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
  padding 0 10px;
`;

export const Line = styled.div`
  display: flex;
  flex: 1;
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  height: 50%;
`;
